<script>
import { EventCategory } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      redirectRoute: { name: 'EventCategory List' }
    }
  },
  computed: {
    service() {
      return EventCategory
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          modelPath: [this, 'form', 'name'],
          multilingual: true,
          required: true
        }),
        new fields.Input({
          label: 'Slug',
          disabled: true,
          modelPath: [this, 'form', 'slug'],
          condition: !!this.form.id
        })
      ]
    }
  }
}
</script>
